// libraries
import styled from "styled-components";
import { flexSmart } from "@caps-mobile/styled-lib";

export const StyledLogo = styled.div`
    ${flexSmart("flex-start center")}
`;